import * as http from "@/utils/request";

export function getCascade({operatorName,brand,operatorId,operatorIds,type,siteGroupId}) {
    return http.get("/devicetype/getCascade",{OperatorName:operatorName,brand,operatorId,operatorIds,type,siteGroupId})
}

export function getSiteGroup({operatorIds}) {
  return http.get("/devicetype/querySiteGroup",{operatorIds})
}




export async function  getSiteIdList(operatorIds) {
   const res=await  getCascade({operatorIds:operatorIds});
   if(res && res.data && res.data.SiteName){
      return  res.data.SiteName.map(item=>{
        return item.id
      })
   }
   return  [];
}
export async function  getSiteList(operatorIds) {
  const res=await  getCascade({operatorIds:operatorIds});
  if(res && res.data && res.data.SiteName){
    return  res.data.SiteName.map(item=>{
      return  {name:item.name,value:item.id}
    })
  }
  return  [];
}

//获取售后角色列表GET /Attendant/findSaleRole
export  const findSaleRole =({operatorId})=>{
  return http.get('/Attendant/findSaleRole',{operatorId})
}

//获取售后绑定的角色值 GET /Attendant/findSaleUserByRole
export  const findSaleUserByRole =({userId})=>{
  return http.get('/Attendant/findSaleUserByRole',{userId})
}



// WEBPACK FOOTER //
// ./src/services/deviceType.js